import React from 'react'
 import useSEO from "./useSEO";

const Accountingoutsourcing = () => {

  useSEO({
  title: "Accounting Outsourcing | Accounting Outsourcing Services In Hyderabad | Accounting Outsourcing Services",
  description: "We provide expert accounting outsourcing services in Hyderabad with 15+ years of experience in construction, real estate, interior, and retail industries.",
  keywords: "accounting outsourcing, bookkeeping services, accounts management, Hyderabad accounting, outsourced accounting, financial services",
  ogTitle: "About Us - 15+ Years of Expertise in Accounting Outsourcing",
  ogDescription: "Trusted accounting outsourcing services with 15+ years of proven experience across construction, real estate, interior, and retail industries.",
  ogImage: "img/accounts-receivable-outsourcing.png",
  twitterTitle: "About Us - 15+ Years of Expertise in Accounting Outsourcing",
  twitterDescription: "Reliable accounting outsourcing services in Hyderabad with 15+ years of industry experience.",
  twitterImage: "img/accounts-receivable-outsourcing.png"
});
  return (
    <div>

        <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> Accounting Outsourcing Services </h1>
          <p className="mb-4">
            We have Decades of Experience with Expertise Team to Streamline your
            Accounting to improve business finances and save your time
            consumption. No need to worry about dealing with piles of paperwork
            or sky-high stacks of receipts. We can help you manage your
            financial documents efficiently, ensuring accuracy and compliance,
            let us handle it all.{" "}
          </p>
          <a href="contact-us.html" className="btn btn-lg btn-dark mb-5">
            <i className="bi bi-telephone me-2" />
            Contact us
          </a>
          {/* Rating */}
          <div className="d-sm-flex align-items-center"></div>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/accounting-outsourcing-services-2.png" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section className="pt-0">
    <div className="container">
      <div className="row ">
        <div className="col-lg-5 position-relative ms-auto">
          {/* Year */}
          <div className="position-absolute top-50 start-0 translate-middle ms-n2">
            <h2 className="heading-color opacity-1 display-4 text-uppercase rotate-270">
              since 2009
            </h2>
          </div>
          {/* Image */}
          <img
            src="img/accounts-receivable-outsourcing.png"
            className="rounded-3 position-relative"
            alt=""
          />
        </div>
        <div className="col-lg-6 mb-5 mb-lg-0">
          {/* Title */}
          <h2 className="mb-3 mb-lg-5">Services We Offer:</h2>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              {" "}
              01
            </div>
            <h6 className="fw-normal mb-0">Accounts Receivable</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              02
            </div>
            <h6 className="fw-normal mb-0">Accounts Payable</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              03
            </div>
            <h6 className="fw-normal mb-0">Bookkeeping</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              04
            </div>
            <h6 className="fw-normal mb-0">Migrating Accounting</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              05
            </div>
            <h6 className="fw-normal mb-0">Internal &amp; External Audit</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3 ">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              06
            </div>
            <h6 className="fw-normal mb-0">Inventory Audit </h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              07
            </div>
            <h6 className="fw-normal mb-0">GST</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              08
            </div>
            <h6 className="fw-normal mb-0">PF, ESIC &amp; PT</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              09
            </div>
            <h6 className="fw-normal mb-0">Financial Reports</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              10
            </div>
            <h6 className="fw-normal mb-0">Budjeting and Forecosting</h6>
          </div>
          {/* Steps */}
          <div className="d-flex align-items-center gap-3">
            <div className="icon-md bg-primary bg-opacity-10 text-primary rounded-circle fw-bold">
              11
            </div>
            <h6 className="fw-normal mb-0">Payroll Management</h6>
          </div>
        </div>
      </div>{" "}
      {/* Row END */} 
    </div>
  </section>
</>

      
    </div>
  )
}

export default Accountingoutsourcing
